// REACT_APP_VERSION, REACT_APP_BUILD_NUMBER and REACT_APP_COMMIT_SHA are set by the GitHub Actions workflow.
const version = process.env.REACT_APP_VERSION;
const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
const commitSha = process.env.REACT_APP_COMMIT_SHA;

export default function BuildStamp() {
  const versionLabel =
    version && buildNumber ? `v${version}.${buildNumber}` : "local build";

  return (
    <p
      className="mt-4 px-4 text-center text-[10px] text-gray-400"
      data-commit={commitSha || undefined}
    >
      © Copyright 2025 B3 Sciences. All rights reserved. · {versionLabel}
    </p>
  );
}
